import { render, staticRenderFns } from "./NoDeliveryIcon.vue?vue&type=template&id=4501ff6a&scoped=true"
import script from "./NoDeliveryIcon.vue?vue&type=script&lang=js"
export * from "./NoDeliveryIcon.vue?vue&type=script&lang=js"
import style0 from "./NoDeliveryIcon.vue?vue&type=style&index=0&id=4501ff6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4501ff6a",
  null
  
)

export default component.exports